import React, { ReactNode } from 'react';
import css from './index.module.css';

interface Props {
  id?: string;
  name?: string;
  label?: string;
  children?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  theme?: string;
  className?: string;
  onClick?: () => void;
}

export default function AuthButton(props: Props) {
  const {
    id,
    name,
    label,
    children,
    type = 'button',
    disabled,
    theme = '',
    className = '',
    ...rest
  } = props;

  return (
    <button
      id={id}
      name={name}
      className={`${css['btn']} ${theme} ${className}`}
      type={type}
      disabled={disabled}
      {...rest}
    >
      {label && <span>{label}</span>}
      {!label && children}
    </button>
  );
}
